<template>
  <b-card>
    <b-row>
      <b-col lg="6" class="mb-4">
        <span class="text-danger text-sm">0 = Intentos ilimitados</span>
        <br>
        <label>Número de intentos permitidos</label>
        <input type="number" v-model="userForm.send_money_intents" class="form-control" placeholder="Monto">
        <span class="text-danger text-sm">Se actualiza cuando el cliente intenta enviar dinero</span>
        <br>
        <label>Número de intentos que ha hecho el cliente</label>
        <input class="form-control" type="number" v-model="userForm.send_money_client_intents"></input>
        <span class="text-danger text-sm">Mensaje que el cliente recibira despues de superar la cantidad de intentos permitidos</span>
        <br>
        <label>Mensaje</label>
        <textarea class="form-control" v-model="userForm.send_money_message"></textarea>
        <b-button  variant="primary" class="mt-2 btn-block" @click="create()">Actualizar información</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {get, post} from "@/util/axiosRequest";

export default {
  name: "Files",
  data: () => ({
    user_id: null,
    file: null,
    list: [],
    userForm: {
      send_money_intents: 0,
      send_money_client_intents: 0,
      send_money_message: ''
    }
  }),
  methods: {

    async  create() {
      if (this.userForm.send_money_message === '' || this.user_id === null) {
        return;
      }
      const id = this.$route.params.id

      await post('user-configuration/update', {
        _id: id,
        ...this.userForm
      }, true);

      this.$swal({
        html: "Información actualizada",
        icon: 'success',
        showCloseButton: true,
        confirmButtonColor: '#191c4d',
        cancelButtonColor: '#191c4d',
      });
      await this.getConfiguration();
    },

    async getConfiguration() {
      const {data} = await get(`user-configuration/find-by-user-id?_id=${this.user_id}`);
      if (!data) {
        return;
      }
      this.userForm.send_money_intents = data.send_money_intents;
      this.userForm.send_money_client_intents = data.send_money_client_intents;
      this.userForm.send_money_message = data.send_money_message;
    }
  },
  mounted() {
    this.user_id = null
    this.user_id = this.$route.params.id;
    this.getConfiguration()
  }
}
</script>

<style scoped>

</style>
